import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { CompartidoModule } from '../compartido/compartido.module';
import { AppBreadcrumbComponent } from './app.breadcrumb.component';
import { AppComponent } from './app.component';
import { AppFooterComponent } from './app.footer.component';
import { AppMenuComponent, AppSubMenuComponent } from './app.menu.component';
import { AppInlineProfileComponent } from './app.profile.component';
import { AppRightpanelComponent } from './app.rightpanel.component';
import { AppTopbarComponent } from './app.topbar.component';
import { SlideMenuModule } from './indices.prime';
import { DataScrollerModule } from './indices.prime';
import { SplitButtonModule } from './indices.prime';
import { SliderModule } from './indices.prime';
import { DialogModule } from './indices.prime';
import { TabMenuModule } from './indices.prime';
import { EditorModule } from './indices.prime';
import { TieredMenuModule } from './indices.prime';
import { TabViewModule } from './indices.prime';
import { FieldsetModule } from './indices.prime';
import { TreeTableModule } from './indices.prime';
import { TooltipModule } from './indices.prime';
import { ToolbarModule } from './indices.prime';
import { GMapModule } from './indices.prime';
import { InputMaskModule } from './indices.prime';
import { CalendarModule } from './indices.prime';
import { ButtonModule } from './indices.prime';
import { BreadcrumbModule } from './indices.prime';
import { InputTextareaModule } from './indices.prime';
import { ListboxModule } from './indices.prime';
import { ColorPickerModule } from './indices.prime';
import { MenubarModule } from './indices.prime';
import { MessagesModule } from './indices.prime';
import { CheckboxModule } from './indices.prime';
import { ChipsModule } from './indices.prime';
import { CodeHighlighterModule } from './indices.prime';
import { ConfirmDialogModule } from './indices.prime';
import { SharedModule } from './indices.prime';
import { ContextMenuModule } from './indices.prime';
import { DataGridModule } from './indices.prime';
import { DataListModule } from './indices.prime';
import { SelectButtonModule } from './indices.prime';
import { DataTableModule } from './indices.prime';
import { SpinnerModule } from './indices.prime';
import { DragDropModule } from './indices.prime';
import { DropdownModule } from './indices.prime';
import { StepsModule } from './indices.prime';
import { TerminalModule } from './indices.prime';
import { FileUploadModule } from './indices.prime';
import { GalleriaModule } from './indices.prime';
import { ToggleButtonModule } from './indices.prime';
import { GrowlModule } from './indices.prime';
import { TreeModule } from './indices.prime';
import { InputSwitchModule } from './indices.prime';
import { InputTextModule } from './indices.prime';
import { AutoCompleteModule } from './indices.prime';
import { LightboxModule } from './indices.prime';
import { ChartModule } from './indices.prime';
import { MegaMenuModule } from './indices.prime';
import { MenuModule } from './indices.prime';
import { CarouselModule } from './indices.prime';
import { AccordionModule } from './indices.prime';
import { MultiSelectModule } from './indices.prime';
import { OrderListModule } from './indices.prime';
import { OrganizationChartModule } from './indices.prime';
import { OverlayPanelModule } from './indices.prime';
import { PaginatorModule } from './indices.prime';
import { PanelModule } from './indices.prime';
import { PanelMenuModule } from './indices.prime';
import { PasswordModule } from './indices.prime';
import { PickListModule } from './indices.prime';
import { ProgressBarModule } from './indices.prime';
import { RadioButtonModule } from './indices.prime';
import { RatingModule } from './indices.prime';
import { ScheduleModule } from './indices.prime';
import { PAGES_ROUTES } from './paginas.route';
import { MenuService } from './servicios/menu.service';
import { ConfiguracionModule } from './configuracion/configuracion.module';
import { PlanificacionModule } from './planificacion/planificacion.module';
import { DisponibilidadService,AsociacionJefeDependenciaService, CateringUnidadService, TipoPersonaService, PlanificacionCateringService
  , CategoriaService, SubCategoriaService, RequerimientoCateringService, EstadoRequerimientoCateringService, ConfiguracionGeneralService, TipoFichaEstandarService, CategoriaFichaEstandarService, ProductoService, ProcesoService, CabeceraFichaEstandarService, DetalleFichaEstandarService, PreparacionFichaEstandarService, AsociacionFichaEstandarXFichaEstandarService, SubCategoriaXCategoriaFichaEstandarService} from 'npm-servicios-catering';
  
import { CustomHttp, DatosSesionService } from '@ucuenca/http-custom';
import { MensajesConstantes } from '../compartido/constantes/mensajes';
import { DatePipe } from '@angular/common';


@NgModule({
  imports: [
    CommonModule
    , FormsModule
    , HttpModule
    , BrowserAnimationsModule


    // ============= Modulos Sistema =============
     ,ConfiguracionModule
     ,PlanificacionModule

    , PAGES_ROUTES
    , CompartidoModule


  ],
  declarations: [
    AppComponent,
    AppMenuComponent,
    AppSubMenuComponent,
    AppTopbarComponent,
    AppFooterComponent,
    AppBreadcrumbComponent,
    AppRightpanelComponent,
    AppInlineProfileComponent,
  
    

  ]
  , providers: [ 
    MenuService,
    DatosSesionService,
    DisponibilidadService,
    AsociacionJefeDependenciaService,
    CateringUnidadService,
    SubCategoriaService,
    RequerimientoCateringService,
    EstadoRequerimientoCateringService,
    TipoPersonaService,
    PlanificacionCateringService,
    ConfiguracionGeneralService,
    CategoriaService,
    CustomHttp,
    MensajesConstantes,
    DatePipe,
    TipoFichaEstandarService,
    CategoriaFichaEstandarService,
    ProductoService,
    ProcesoService,
    CabeceraFichaEstandarService,
    DetalleFichaEstandarService,
    PreparacionFichaEstandarService,

    AsociacionFichaEstandarXFichaEstandarService,
     
    SubCategoriaXCategoriaFichaEstandarService

    
  ]
  , exports: [
    AppComponent
    , BrowserAnimationsModule
    
    // =============== componetes sistema

    
    // ========== FIN MODULOS PRIME =======

  ]
})
export class PaginasModule { }
